// extracted by mini-css-extract-plugin
module.exports = {"card":"aed17b9412--card--jBAsh"};